import { Navigate } from "react-router-dom"
import { useAuth } from "../authContext"
import { canAccessPage } from "../pageAccess"

const ProtectedRoute = ({
  pageKey,
  pageKeys,
  children,
}: {
  pageKey?: string
  pageKeys?: string[]
  children: JSX.Element
}) => {
  const { allowedPages } = useAuth()
  const keys = pageKeys ?? (pageKey ? [ pageKey ] : [])
  const allowed = keys.some(k => canAccessPage(allowedPages, k))
  if (!allowed) {
    return <Navigate replace to="/forbidden" />
  }
  return children
}

export default ProtectedRoute
